import { render } from "./forget.vue?vue&type=template&id=17f901e0&scoped=true"
import script from "./forget.vue?vue&type=script&lang=js"
export * from "./forget.vue?vue&type=script&lang=js"

import "./forget.vue?vue&type=style&index=0&id=17f901e0&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\YDN\\trunk\\zulin-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17f901e0"]])

export default __exports__